import React from 'react';
import closeBtn from '../assets/images/close_btn.png'

const Modal = ({ isOpen, onClose, children, onCloseBtn, width, onClickBack }) => {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 text-[#50555F]"
             {...(onClickBack ? { onClick: onClose } : {})} // 조건부로 onClick 추가
        >
            <div className={`relative bg-white rounded-[20px] shadow-lg w-[${width ? width : 446}px] pt-[19px] pb-[32px]`}>
                {onCloseBtn && (
                    <button
                        onClick={onClose}
                        className="absolute top-[20px] right-[16px] text-gray-500 hover:text-gray-700 text-xl"
                    >
                       <img
                           src={closeBtn}
                           alt="clost btn"/>
                    </button>
                )}
                {children}
            </div>
        </div>
    );
};



export default Modal;